// Design: components/settings/SyncCode.tsx (line-numbered, lightly highlighted code).
const TOKEN = /("(?:[^"\\]|\\.)*"(?=\s*:))|("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')|(\/\/[^\n]*|#[^\n!{]*$)|\b(true|false|null|-?\d+(?:\.\d+)?)\b|\b(curl|const|let|await|async|import|from|return|function|def|if|else|new|print)\b|(\s-[A-Za-z]\b|\s--[a-z-]+)/gm;

function highlight(line) {
  const parts = [];
  let last = 0;
  for (const match of line.matchAll(TOKEN)) {
    const start = match.index ?? 0;
    if (start > last) parts.push({ text: line.slice(last, start), className: "text-paper/80" });
    const className = match[1] ? "text-paper" : match[2] ? "text-sky" : match[3] ? "text-paper/45 italic" : match[4] ? "text-sun" : match[5] ? "text-sky-soft font-semibold" : "text-paper/55";
    parts.push({ text: match[0], className });
    last = start + match[0].length;
  }
  if (last < line.length) parts.push({ text: line.slice(last), className: "text-paper/80" });
  return parts;
}

export function SyncCode({ code }) {
  return <div className="max-h-72 overflow-auto py-3"><pre className="font-mono text-[12.5px] leading-[22px]"><code className="grid grid-cols-[2.75rem_minmax(0,1fr)]">{code.split("\n").map((line, index) => <span key={index} className="contents"><span aria-hidden className="select-none pr-3 text-right text-paper/25 tabular-nums">{index + 1}</span><span className="whitespace-pre-wrap break-words pr-4">{highlight(line).map((part, partIndex) => <span key={partIndex} className={part.className}>{part.text}</span>)}{line === "" ? " " : ""}</span></span>)}</code></pre></div>;
}
